export const comments_5129830 = {"data":{"data":[],"links":{}}}